import { render, staticRenderFns } from "./ManageRequestsHeader.vue?vue&type=template&id=61c7d6ee&scoped=true&"
import script from "./ManageRequestsHeader.vue?vue&type=script&lang=js&"
export * from "./ManageRequestsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequestsHeader.vue?vue&type=style&index=0&id=61c7d6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c7d6ee",
  null
  
)

export default component.exports